/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { RequestStatus } from '../models/RequestStatus';
import { SimpleUser } from '../models/SimpleUser';
import { HttpFile } from '../http/http';

export class UserFollowRequest {
    'id': number;
    'requester': SimpleUser;
    'user': SimpleUser;
    'dtCreated': Date;
    'status'?: RequestStatus;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": ""
        },
        {
            "name": "requester",
            "baseName": "requester",
            "type": "SimpleUser",
            "format": ""
        },
        {
            "name": "user",
            "baseName": "user",
            "type": "SimpleUser",
            "format": ""
        },
        {
            "name": "dtCreated",
            "baseName": "dtCreated",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "RequestStatus",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return UserFollowRequest.attributeTypeMap;
    }

    public constructor() {
    }
}



